(ns com.theplantscape.plant-web.pages.profile
  (:require
   [clojure.string :as str]
   [reagent.core :as r]
   [tick.core :as t]
   ;;[tick.locale-en :as tl-en]
   [tick.locale-en-us :as tl-us]
   [reitit.frontend.easy :as rfe]
   [clojure.core.async :refer [<! go]]
   [com.theplantscape.plant-web.api.diagrams :refer [delete-user-diagram delete-user-diagram-async create-user-diagram] :as d]
   [com.theplantscape.plant-web.pages.missing-page :refer [ui-page-not-authorized]]
   [com.theplantscape.plant-web.api.diagrams
    :refer [fetch-user-diagram-list]]
   [com.theplantscape.plant-web.components.tailwind.forms.diagrams :refer [ui-form-create-diagram]]
   [com.theplantscape.plant-web.api.polycultures
    :refer [delete-polyculture fetch-polycultures create-new-polyculture]]
   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-async button]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state site-state build-api-url]]
   [com.theplantscape.plant-web.api.user :refer [api-fetch-user-proile api-update-user-proile]]
   [com.theplantscape.web-ui.tailwind.buttons :refer [ui-btn-link ui-btn-action]]
   [com.theplantscape.plant-web.components.forms.core :refer [replace-slash-in-name-attributes]]
   [com.theplantscape.web-ui.tailwind.ensemble
    :refer [grid-layout grid-layout-one picture]]
   [com.theplantscape.plant-web.components.tailwind.forms.user :refer [ui-form-user]]
   [com.theplantscape.plant-web.components.tailwind.forms.polycultures :refer [ui-form-create-polyculture]]))

(defn date-formatter [date] (when date (t/format (t/formatter "yyyy-MMM-dd") (t/zoned-date-time date))))

(defn api-handler-response [handler [state payload]]
  (if state
    (handler payload)
    (do
      ;; If somethin goes wrong pass nil to handler we can reset the state then
      (handler nil)
      (case (:status payload)
        401 (do (prn "401 unauth")
                (swap! site-state assoc :auth nil))
        (prn (str "Unhandled " state " - " payload))))))

(defn load-user-polyculture []
  (go (api-handler-response
       (partial swap! app-state assoc-in [:user :polycultures])
       (<! (fetch-polycultures "user")))))

(defn load-user-diagrams []
  (go (api-handler-response
       (partial swap! app-state assoc-in [:user :diagrams])
       (<! (fetch-user-diagram-list {:list "user"})))))

(defn init-profile-page []
  (go (api-handler-response
       (partial swap! app-state assoc-in [:user :profile])
       (<! (api-fetch-user-proile))))

  (load-user-polyculture)
  (load-user-diagrams))

(defn ui-grid-item-diagram [{:keys [diagram detail]}]
  [:div.relative
   {:keys (:xt/id diagram)}
   [:div.absolute.left-0.top-0.bg-tps-primary
    [:a
     {:href (rfe/href :schedule {:diagram-id (:xt/id diagram)})}
     "Calendar"]]
   [:a.justify-centre.content-center.button
    {:href (rfe/href :diagram {:id (:xt/id diagram)})}
    [picture
     {:alt (str "Overview of " (:diagram/title diagram))
      :image (@build-api-url "/api/v2/diagrams/png/" (:xt/id diagram))}]
    [:div.absolute.right-0.top-0.bg-tps-primary
     [button-progress-async
      "Delete"
      {:on-click (partial delete-user-diagram-async (:xt/id diagram))
       :on-complete (fn [response] (load-user-diagrams))}]]
    [:div.p-4
     [:h6 (str (:diagram/title diagram))]
     [:p (str (:diagram/description detail) #_(item))]]]])

(defn ui-grid-item-polculture [item]
  [:div.relative
   {:keys (:xt/id item)}
   [:a.justify-centre.content-center.button
    {:href (rfe/href :polyculture {:id (:xt/id item)})}
    [picture
     {:alt (str "Overview of " (:polyculture/title item))
      :image (@build-api-url "/api/v2/polyculture/png/" (:xt/id item))}]
    [:div.absolute.right-0.top-0.bg-tps-primary
     [button-progress-async
      "Delete"
      {:on-click (partial delete-polyculture (:xt/id item))
       :on-complete (fn [response] (load-user-polyculture))}]]
    [:div.p-4
     [:h6 (str (:polyculture/title item))]
     [:p (str (:polyculture/description item) #_(item))]]]])

(defn ui-grid [ui-grid-item items]
  [grid-layout
   4
   (into [] (mapv ui-grid-item items))])

(defn authed-view [view params]
  (view params))

(defn create-diagram [data]
  (create-user-diagram (replace-slash-in-name-attributes data)))

(defn create-polyculture [data]
  (create-new-polyculture (replace-slash-in-name-attributes data)))

(defn update-profile [data]
  (api-update-user-proile
   (replace-slash-in-name-attributes data)))

(defn profile-page-main [{:keys [query path] :as params}]
  (let [edit (r/atom false)
        show-create-design (r/atom false)
        show-create-polyculture (r/atom false)
        user-profile (r/cursor app-state [:user :profile])
        users-polycultures (r/cursor app-state [:user :polycultures])
        users-diagrams (r/cursor app-state [:user :diagrams])]

    (fn [{:keys [query path] :as params}]
      [:main.pa3.black-80
       [:div
        [:p "Welcome back " (str/capitalize (:user/display-name @user-profile))]
        (when (:user/created @user-profile) 
          [:p "Member since " (date-formatter (:user/created @user-profile))])
        [button {:on-click #(reset! edit (not @edit))} "Edit"]
        [ui-btn-link {:text "Change password"
                      :class "ml-4"
                      :href (rfe/href :route-forgot-password)}]
        #_[ui-btn-link {:text "Register security key"
                        :href (rfe/href :route-forgot-password)}]]

       (when @edit
         [:div.m-4
          [ui-form-user
           (r/atom {:values (-> @app-state :user :profile)})
           {:on-submit update-profile
            :on-submit-complete prn}]])

       [:h2 "Your designs"]
       [:div.flex.flex-auto.mb-4
        [:div.mb-4.mt-4.grow "Create a new diagram"]
        [ui-btn-action "Create diagram" #(swap! show-create-design not)]]

       (when @show-create-design
         [:div.bg-tps-primary.p-4.mt-4.mb-4
          [ui-form-create-diagram
           (r/atom {:values {}})

           {:on-submit create-diagram
            :on-submit-complete
            (fn []
              (reset! show-create-design false)
              (load-user-diagrams))}]])

       (when (seq @users-diagrams)
         [ui-grid
          ui-grid-item-diagram
          @users-diagrams])

       [:h2 "Your polycultures"]
       [:div.flex.flex-auto.mb-4
        [:div.mb-4.mt-4.grow "Create a new polyculture"]
        [ui-btn-action "Create polyculture" #(swap! show-create-polyculture not)]]

       (when @show-create-polyculture
         [:div.bg-tps-primary.p-4.mt-4.mb-4
          [ui-form-create-polyculture
           (r/atom {:values {}})
           {:on-submit create-polyculture
            :on-submit-complete
            (fn []
              (reset! show-create-polyculture false)
              (load-user-polyculture))}]])

       (when (seq @users-polycultures)
         [ui-grid
          ui-grid-item-polculture
          @users-polycultures])])))

(defn profile-page [params]
  (if (-> @app-state :user :profile)
    [profile-page-main params]
    [ui-page-not-authorized (-> @app-state :user :profile)]))
